export const formatAddress = (
  addressLine1: string,
  addressLine2: string,
  city: string,
  state: string,
  zipcode: string,
) =>
  `${addressLine1 ? `${addressLine1}, ` : ""}${addressLine2 ? `${addressLine2}, ` : ""}${city}, ${state}, ${zipcode}`.trim();
